import styles from "./Projects.module.css"
import { ProjectsData } from "./ProjectData"

export const Projects = () => {


    return <div id="Projects" className={styles.Projects_container}>

        <div className={styles.Projects_inside_container}>

            <h2 className={styles.Projects_heading}>Projects</h2>
            {/* <p>I’ll help <span>visualize your creative ideas.</span> From web design to developing user friendly wesites.</p> */}

            <div className={styles.works}>

                {ProjectsData.map((e) => {

                    return <div className={styles.work}>
                        <div>
                            <div className={styles.content}>

                                <h3>{e.ProjectName}</h3>

                                <p className={styles.description}>{e.ProjectDescription}</p>

                                <div className={styles.middle}>
                                    <div className={styles.ProjectLinks}>
                                        <a href={e.GithubLink} className={styles.hover_underline_animation} target="_blank" rel="noreferrer">Github</a>
                                        <a href={e.LiveDemoLink} className={styles.hover_underline_animation} target="_blank" rel="noreferrer">Live-Demo</a>
                                        <a href={e.MediumLink} className={styles.hover_underline_animation} target="_blank" rel="noreferrer">Blog</a>
                                    </div>
                                    <div className={styles.tags}>
                                        {e.TechUsed.map((e) => {
                                            return <>
                                                <p>{e}</p>
                                            </>
                                        })}
                                    </div>
                                </div>

                                <h4 className={styles.year}>{e.year}</h4>

                            </div>

                        </div>

                        <div>
                            <a href={e.LiveDemoLink} target="_blank" rel="noreferrer">
                                <img src={e.image} alt="" />
                            </a>
                        </div>

                    </div>
                })}

            </div>
        </div>
    </div>

}
